// ABOUTME: Loading overlay component for showing loading state over content.
// ABOUTME: Displays a semi-transparent backdrop with a centered spinner.

import type { FC } from "react"
import { CSpinnerInline } from "./CSpinnerInline"

interface CLoadingOverlayProps {
  loading: boolean
}

export const CLoadingOverlay: FC<CLoadingOverlayProps> = ({ loading }) => {
  if (!loading) return null

  return (
    <div className="absolute inset-0 bg-white/50 flex items-center justify-center rounded-[20px] z-10">
      <CSpinnerInline loading />
    </div>
  )
}
